<template>
	<div>
		<div v-if="isLoading" class="mobile-spinnerstyle">
			<MobileSpinner />
		</div>
		<div class="screenSizeLap">
			<div class="login-main-container">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<div class="login-main-sub-container position-relative">
						<div
							class="w-100 d-flex justify-content-center align-items-baseline mb-3"
						>
							<img
								src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/Hire3x_Website_Header.svg"
								style="
									display: block;
									visibility: visible;
									opacity: 1;
									height: 40px;
								"
								alt=""
							/>
						</div>
						<div
							class="d-flex align-items-center flex-column text-center internetcheck-page-container"
						>
						<embed
							style="display: none"
							id="pdfEmbed"
							src="../assets/check-upload-speed.pdf"
							width="100%"
							height="500px"
							type="application/pdf"
						/>
						<div class="internetcheck-content-wrapper d-flex h-100 flex-column justify-content-center align-items-center">
							<h1 v-if="!bothFetched" class="fw-500 check-speed-heading">
								Checking your Internet Speed
							</h1>
							<div class="w-100">
								<div
									class="d-flex align-items-center justify-content-around flex-column mt-4 w-100"
								>
									<div
										v-if="!bothFetched"
										class="intspd-cardcontainer intspd-meter-container d-flex flex-column align-items-center justify-content-center p-4"
									>
										<div class="i-guage position-relative mt-4 mb-4">
											<div class="i-guage__body">
												<div class="i-guage__fill"></div>
												<div class="i-guage__cover">
													<img
														:style="`transform: rotate(${angleValue}deg)`"
														class="speedometer-origin"
														id="speed-img"
														src="../assets/newimgs/speedometerArrow.svg"
														alt=""
													/>
												</div>
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="left: -26px; bottom: -5px"
											>
												0
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="left: -10px; bottom: 47px"
											>
												10
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="top: -20px; left: 26px"
											>
												30
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="top: -37px; right: 84px"
											>
												50
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="top: -20px; right: 18px"
											>
												70
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="right: -18px; bottom: 46px"
											>
												90
											</div>
											<div
												class="position-absolute speedometer-txt"
												style="right: -52px; bottom: -5px"
											>
												100+
											</div>
										</div>
									</div>
									<div
										v-else
										class="intspd-cardcontainer d-flex flex-column align-items-center justify-content-center p-4"
									>
										<div
											class="intspd-main-text d-flex align-items-center justify-content-center"
										>
											<div
												v-if="isNetSpeed"
												class="d-flex align-items-center justify-content-center flex-column"
											>
												<img
													src="../assets/newui-img/icstable.svg"
													alt=""
													class="my-1"
												/>
												Your internet speed is stable.
												<br />
												Click "Next" to proceed with the test
											</div>
											<div
												v-else
												class="d-flex align-items-center justify-content-center flex-column"
											>
												<img
													src="../assets/newui-img/warning.svg"
													alt=""
													class="my-1"
												/>
												Due to a slow internet connection, the test
												<br />
												cannot be taken.
											</div>
										</div>
										<div
											v-if="bothFetched"
											class="mt-5 d-flex align-items-center justify-content-center bluebtns"
										>
											<b-button
												v-if="isNetSpeed"
												@click="next()"
												class="w-100px candash-addBtn"
												variant="primary"
												>Next</b-button
											>
											<b-button
												@click="resetAllValues"
												v-else
												class="w-100px candash-addBtn"
												variant="primary"
												>Retry</b-button
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
		<div v-if="!isLoading">
			<div class="screenSizeMobile" v-if="AllowedMobAndLap !== null">
				<MobileInternetCheck v-if="AllowedMobAndLap" />
				<Block v-else />
			</div>
		</div>
	</div>
</template>

<script>
import { candidateSystemCheck } from "../apiFunction";
import Block from "../components/mobileView/Block.vue";
import MobileInternetCheck from "../components/mobileView/MobileNewInternetCheck.vue";
import internet from "../mixins/internet";
export default {
	data() {
		return {
			property: "value",
			AllowedMobAndLap: null,
		};
	},
	mixins: [internet],
	components: {
		MobileInternetCheck,
		Block,
	},

	async created() {
		await this.getdata();
		await this.getMobileVerification();
	},
	methods: {
		async getMobileVerification() {
			this.isLoading = true;
			try {
				let res = await candidateSystemCheck(`?uuid=${this.$route.query.uuid}`);
				if (res.status === 200) {
					this.AllowedMobAndLap = true;
				} else {
					this.AllowedMobAndLap = false;
				}
			} catch (error) {
				this.AllowedMobAndLap = false;
			} finally {
				this.isLoading = false; // hide spinner only after API is done
			}
		},
	},
};
</script>
<style>
@media only screen and (max-width: 1024px) {
	.screenSizeLap {
		display: none;
	}
}
@media only screen and (min-width: 1024px) {
	.screenSizeMobile {
		display: none;
	}
}

.internetcheck-page-container {
	border-radius: 14px;
	background: url("../assets/newui-img/internetcheck.png");
	background-repeat: no-repeat;
	background-size: cover;
	padding: 30px;
	height: calc(100vh - 125px);
	width: 100%;
	overflow: auto;
}

@media only screen and (max-width: 1024px) {
	.check-speed-heading {
		font-size: 22px !important;
	}
	.internetcheck-page-container {
		padding: 15px !important;
	}
	.intspd-meter-container {
		background: transparent !important;
		box-shadow: none !important;
	}
	.intspd-cardcontainer {
		height: 290px !important;
	}
	.i-guage {
		transform: scale(1.15) !important;
	}
	.internetcheck-page-container{
		height: calc(100dvh - 90px) !important;
		overflow: hidden !important;
	}
	.login-main-sub-container {
		width: 100% !important;
		padding: 17px 20px 30px 20px !important;
	}
}

.intspd-cardcontainer {
	border-radius: 14px;
	background: #fff;
	box-shadow: 0px 15px 30px 0px rgba(122, 122, 122, 0.2);
	width: 100%;
	max-width: 590px;
	height: 340px;
}

.intspd-main-text {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 22px;
	text-align: center;
	color: #636363;
}

.i-guage {
	border: 8.107px solid #f5eeee;
	border-bottom: none;
	border-top-left-radius: 100% 200%;
	border-top-right-radius: 100% 200%;
	width: 100%;
	max-width: 200px;
	transform: scale(1.25);
}

.i-guage__body {
	width: 100%;
	height: 0;
	padding-bottom: 50%;
	background: #b4b4b4;
	position: relative;
	border-top-left-radius: 100% 200%;
	border-top-right-radius: 100% 200%;
	overflow: hidden;
}

.i-guage__fill {
	background: #4c78ce;
	position: absolute;
	top: 100%;
	left: 0;
	width: inherit;
	height: 100%;
	transform-origin: center top;
	transform: rotate(0.5turn);
	transition: transform 0.2s ease-out;
}

.i-guage__cover {
	border: 8.107px solid #f5eeee;
	background: white;
	width: 94%;
	height: 187%;
	border-radius: 50%;
	position: absolute;
	top: 7%;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 25%;
}

.speedometer-origin {
	transform-origin: 50% 70%;
	transition: 0.5s all linear;
}

.speedometer-txt {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	color: #696969;
}

.check-speed-heading {
	color: #333333;
	font-family: "Lato", sans-serif;
	font-size: 30px;
	font-style: normal;
}

.internetcheck-content-wrapper {
	width: 75%;
}
@media only screen and (max-width: 768px) {
	.internetcheck-content-wrapper {
		width: 100%;
	}
}
</style>
